@if(!universalService.inAppWebViewOpened){
    <!-- <p>{{userData.authProviderId }}</p> -->
    @if(userData.authProviderId == 2 || userData.authProviderId == 3 || userData.authProviderId == 5 || userData.authProviderId == 7){
        <div class="banner-cont  mt-1 mb-2 " >
            <p>Social login will be discontinued permanently on 30th April, 2025. Please export your data before this date.</p>
            <button class="banner-button ng-star-inserted" (click)="redirectToDataExport();">Export Now</button>
        </div>
    }
}